import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetAgeSexRisk = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_AGE_SEX_RISK, token);
  return res;
};

export const GetAgeSexRiskDetails = async (ageSexRiskId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_AGE_SEX_RISK_DETAILS, token);
  return res;
};

export const AddAgeSexRisk = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_AGE_SEX_RISK, payload, token);
  return res;
};

export const UpdateAgeSexRisk = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_AGE_SEX_RISK, payload, token);
  return res;
};

export const DeleteAgeSexRisk = async (id) => {
  const token = localStorage.getItem("token");
  const params = { id };
  let res = await Services.DELETE(Url.DELETE_AGE_SEX_RISK + id, params, token);
  return res;
};
